import { render, staticRenderFns } from "./MainModal.vue?vue&type=template&id=6b37e25a&scoped=true"
import script from "./MainModal.vue?vue&type=script&lang=js"
export * from "./MainModal.vue?vue&type=script&lang=js"
import style0 from "./MainModal.vue?vue&type=style&index=0&id=6b37e25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b37e25a",
  null
  
)

export default component.exports